import { render, staticRenderFns } from "./terminal.vue?vue&type=template&id=1dc06fb9&scoped=true"
import script from "./terminal.vue?vue&type=script&lang=js"
export * from "./terminal.vue?vue&type=script&lang=js"
import style0 from "./terminal.vue?vue&type=style&index=0&id=1dc06fb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc06fb9",
  null
  
)

export default component.exports